import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddEmployeeModal = ({ isOpen, setEmployees }) => {
  const company = localStorage.getItem('name') || '';
  const key = localStorage.getItem('key') || '';
  const cid = localStorage.getItem('authToken') || '';
  const type = 'add';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    department: '',
    company,
    cid,
    key,
    type,
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    try {
      const data = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        department: formData.department,
        contactNumber: formData.contact,
        company: formData.company,
        cid: formData.cid,
        key: formData.key,
        type: formData.type,
      });

      const response = await fetch(
        'https://app.mindstreamsoft.com/crp_employee.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: data,
        }
      );

      const rawResponse = await response.text();

      const jsonMatch = rawResponse.match(/\{.*\}/s);
      let result;

      if (jsonMatch) {
        try {
          result = JSON.parse(jsonMatch[0]);
        } catch (jsonError) {
          throw new Error(`Invalid JSON in response: ${jsonMatch[0]}`);
        }
      }

      if (response.ok) {
        const successMessage =
          result?.message || 'Employee added successfully!';
        toast.success(successMessage, {
          autoClose: 2000,
          style: { zIndex: 1051 },
        });

        setFormData({
          name: '',
          email: '',
          contact: '',
          department: '',
          company: localStorage.getItem('name'),
          cid: localStorage.getItem('cid'),
          key: localStorage.getItem('key'),
          type,
        });

        setEmployees((prevEmployees) => [
          ...prevEmployees,
          {
            id: result.id,
            name: formData.name,
            email: formData.email,
            contact: formData.contact,
            department: formData.department,
          },
        ]);
      } else {
        throw new Error(result?.message || `Server Error: ${response.status}`);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Failed to add employee. Please try again.');
    }
  };

  const handleBackToDashboard = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(5px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '20px',
          padding: '50px',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
          animation: 'fadeIn 0.3s ease-in-out',
        }}
      >
        <h2
          style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '25px',
          }}
        >
          Add New Employee
        </h2>
        <form onSubmit={(e) => e.preventDefault()}>
          <label style={{ color: '#1f1f21' }}>
            Name<span style={{ color: '#df2d2d' }}>*</span>
          </label>
          <input
            type='text'
            name='name'
            placeholder='Enter Name'
            value={formData.name}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '8px',
              marginBottom: '20px',
              borderRadius: '8px',
              background: '#f5f5fa',
            }}
          />
          <label style={{ color: '#1f1f21' }}>
            Email<span style={{ color: '#df2d2d' }}>*</span>
          </label>
          <input
            type='email'
            name='email'
            placeholder='Enter Email'
            value={formData.email}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '8px',
              marginBottom: '20px',
              borderRadius: '8px',
              background: '#f5f5fa',
            }}
          />
          <label style={{ color: '#1f1f21' }}>
            Contact<span style={{ color: '#df2d2d' }}>*</span>
          </label>
          <input
            type='text'
            name='contact'
            placeholder='Enter Contact Number'
            value={formData.contact}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '8px',
              marginBottom: '20px',
              borderRadius: '8px',
              background: '#f5f5fa',
            }}
          />
          <label style={{ color: '#1f1f21' }}>Department</label>
          <input
            type='text'
            name='department'
            placeholder='Enter Department Name'
            value={formData.department}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '8px',
              marginBottom: '20px',
              borderRadius: '8px',
              background: '#f5f5fa',
            }}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px',
              marginTop: '15px',
            }}
          >
            <button
              type='button'
              onClick={handleSaveChanges}
              style={{
                backgroundColor: '#ff7a00',
                color: '#fff',
                border: 'none',
                padding: '5px 20px',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Save Changes
            </button>
            <button
              type='button'
              onClick={handleBackToDashboard}
              style={{
                backgroundColor: '#fff',
                color: '#1f1f21',
                border: '1px solid #969696',
                padding: '5px 20px',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Back to Dashboard
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeModal;
